import React    from 'react'
import CountUp  from './CountUp'

const CountUpWrapper = ({ amount, ...props }) =>
  <CountUp {...props} startVal={Math.ceil(amount * 0.95)} endVal={amount} />

export default CountUpWrapper
